module.exports = __webpack_public_path__ + "img/5.82f78c8b.svg";